import { render, staticRenderFns } from "./BB-question.vue?vue&type=template&id=f559cb04&"
import script from "./BB-question.vue?vue&type=script&lang=js&"
export * from "./BB-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports